import React, { useState, useEffect } from 'react';
import ModernLayout from './ModernLayout';
import PresentationAnalysisLeftPanel from './PresentationAnalysisLeftPanel';
import PresentationAnalysisCenterPanel from './PresentationAnalysisCenterPanel';
import LoadingOverlay from './LoadingOverlay';
import './ModernPresentationAnalysis.css';

const ModernPresentationAnalysis = ({ 
  availableOptions, 
  selectedOptions, 
  onOptionChange,
  presentationContent,
  loading,
  error,
  onGenerate
}) => {
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [activeSection, setActiveSection] = useState(null);

  // Page loading effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPageLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const handleSectionClick = (sectionId) => {
    setActiveSection(sectionId);
    // Scroll to section in center panel
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const leftPanel = (
    <PresentationAnalysisLeftPanel
      availableOptions={availableOptions}
      selectedOptions={selectedOptions}
      onOptionChange={onOptionChange}
      onGenerate={onGenerate}
    />
  );

  const centerPanel = (
    <PresentationAnalysisCenterPanel
      presentationContent={presentationContent}
      loading={loading}
      error={error}
      activeSection={activeSection}
      onSectionClick={handleSectionClick}
    />
  );

  return (
    <>
      {/* Loading Overlay */}
      <LoadingOverlay
        title="AI Earnings Assistant"
        message="Loading presentation data..."
        show={isPageLoading}
      />

      {/* Modern Layout with Two Panels */}
      <ModernLayout
        leftPanel={leftPanel}
        showTwoPanel={true}
      >
        {centerPanel}
      </ModernLayout>
    </>
  );
};

export default ModernPresentationAnalysis;
